export const MEETINGS_HISTORY_MIN_ROWS = 0
export const MEETINGS_HISTORY_PAGE_SIZES = [15, 25, 50, 100]
export const MEETINGS_HISTORY_DEFAULT_ROWS = 25